export default __webpack_public_path__ + "static/media/SolidWorks-01.4a75c5cd.svg";